import { Dialog } from "@/design-system/Dialog/Dialog";
import { useTranslation } from "@repo/shared/i18n";
import { ReactNode } from "react";

interface BaseEvoPopupProps {
  handleOnClose: () => void;
  title: string;
  children: ReactNode;
  imageUrl?: string;
  posLabel: string;
  onPositive: () => void;
  posDisabled?: boolean;
}

/**
 * The evolution hub's confirm popups on the 2.0 Dialog, illustration on top.
 * The confirm action never closes on its own: some popups stay up until their
 * save lands, and the rest close in their own handler.
 */
export const BaseEvoPopup = ({
  handleOnClose,
  title,
  children,
  imageUrl,
  posLabel,
  onPositive,
  posDisabled,
}: BaseEvoPopupProps) => {
  const { t } = useTranslation("common");
  return (
    <Dialog
      isOpen
      onClose={handleOnClose}
      title={title}
      negLabel={t("cancel")}
      posLabel={posLabel}
      onPositive={onPositive}
      posDisabled={posDisabled}
      closeOnPositive={false}
      width={480}
    >
      <div className="flex flex-col gap-y-4">
        {imageUrl && (
          <img
            src={imageUrl}
            alt=""
            className="h-48 w-full rounded-2xl object-cover"
          />
        )}
        {children}
      </div>
    </Dialog>
  );
};
